import {DisplayFilter} from "./filters.component";
import {EventEmitter} from "@angular/core";

export abstract class FilterService {
    public filterUpdated:EventEmitter<any>;
    abstract applyFilters(filter: DisplayFilter, item: any, emitChangeEvent?: boolean);
    abstract clearFilter(filter: DisplayFilter, emitChangeEvent?: boolean);
    abstract clearAllFilters(emitChangeEvent?: boolean);
    abstract getFilters();
    abstract getFilter(filter: DisplayFilter);
    abstract setFilters(facetFields: any[]);
    abstract getDisplayFilters(): DisplayFilter[];
}